var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-5 mt-5"},[_c('v-row',[_c('v-col',{staticClass:"pa-3 col-12 col-md-6"},[_c('Signin')],1),_c('v-col',{staticClass:"pa-3 col-12 col-md-6"},[_c('Signup')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }